module.exports = __webpack_public_path__ + "img/start-bar.b4fd3d79.gif";